import React, { ReactNode } from 'react'

import { cn } from '@/utils/style.ts'

export interface TimelineProps {
  children: ReactNode
  className?: string
}

export interface TimelineItemProps {
  children: ReactNode
  dot?: ReactNode
  color?: string
  index?: number
  className?: string
  contentClassName?: string
}

export const Timeline: React.FC<TimelineProps> = ({ children }) => {
  return (
    <div className="relative">
      <div className="absolute top-0 bottom-0 left-[5.5px] w-px bg-[#E1E4EA]"></div>
      <div className="">
        {React.Children.map(children, (child) => {
          if (React.isValidElement(child)) {
            return React.cloneElement(child)
          }
          return child
        })}
      </div>
    </div>
  )
}

export const TimelineItem: React.FC<TimelineItemProps> = ({ children }) => {
  return (
    <div className="relative">
      <div className="absolute top-[15px] z-10">
        {/* dot */}
        <div
          className={cn(
            'w-3 h-3 rounded-full flex items-center justify-center bg-[#2bcaa5] border-2 border-[#F1FCF8]',
          )}
        ></div>
      </div>
      <div className="pl-6">{children}</div>
    </div>
  )
}
